import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Iframe from "./../../components/Iframe";
import { ConfigSettings } from "../../config/Config";
import { useGeneralContext } from "../General/Context";
import { useHistory } from "react-router-dom";
import { QueryString } from "../../common/helper";
import { searchService } from "../../services/searchService";
import { iframeService } from "../../services/iFrameService";
import PaperIcon from "../../layout/left_menu_icons/paper.svg";
import "../dashboard/styleDashboard.scss";

export default function PreProposalsList() {
  const settings = ConfigSettings();
  const { t } = useTranslation();
  let history = useHistory();
  const { userInformation } = useGeneralContext();
  const [url, setUrl] = useState("");
  const candidateEmail = 0;
  function goToInterviewDetails({ data }) {
    if (data.args[candidateEmail].length > 0) {
      searchService.search(data.args[candidateEmail]).then((interviewInfo) => {
        if (interviewInfo.length > 0) {
          history.push(
            `/interview/view/${
              interviewInfo[0].id
            }?&returnUrl=%2Fpreproposals%3FiframeUrl%3D+${
              data[1] ? data[1] : ""
            }`
          );
        }
      });
    }
  }
  const messagehandllers = {
    origin: settings.outSystemBaseUrl,
    open_interview: goToInterviewDetails
  };
  //a espera de update do lado do outsystem
  function setIframeUrl() {
    let iframeUrl = QueryString.getUrlParameter("iframeUrl");
    let status = QueryString.getUrlParameter("status");
    if (iframeUrl) {
      setUrl(iframeUrl);
    } else {
      iframeService
        .GetProposalByStatus(status)
        .then((data) =>
          setUrl(
            `${settings.riseUrl}/external/access?k=${encodeURIComponent(
              data.key
            )}`
          )
        );
    }
  }

  useEffect(() => {
    setIframeUrl();
  }, [userInformation.companyAbbreviation]);

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            <img src={PaperIcon} alt="ni-icon" />
            <h1 style={{ marginTop: "10px" }}>{t("Proposals")}</h1>
          </div>
        </div>
      </header>
      {url && <Iframe url={url} messagehandllers={messagehandllers} />}
    </>
  );
}
